<template>
        <el-dialog title="新增" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item :label="dicTypeName">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.note"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                dicTypeNameGroup:['电子标签类型'],
                dicTypeName:'',
                rules: {
                    FName: [{required: true,message: '请输入'+this.dicTypeName, trigger: 'blur'}]
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag;
            },
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
                this.dicTypeName = this.dicTypeNameGroup[record.FType-1];
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = {id:0,dicType:record.dicTypeID};
                this.dicTypeName = this.dicTypeNameGroup[record.dicTypeID-1];
            },
            save:function () {
                util.post("server/system/SetType.ashx?cmd=Save",this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/SetType_Edit.vue